import { useState, useEffect } from 'react';
import { X, Loader2 } from 'lucide-react';
import { getCachedStreamUrl } from '../../utils/bunnyStream';

export default function CourseTrailerModal({ courseVideoId, onClose }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [signedUrl, setSignedUrl] = useState(null);

  // Close on Escape key
  useEffect(() => {
    const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  // Generate signed URL client-side (instant)
  useEffect(() => {
    if (!courseVideoId) {
      setError('معرف الفيديو مفقود.');
      setLoading(false);
      return;
    }

    getCachedStreamUrl(courseVideoId)
      .then(url => {
        if (url) setSignedUrl(url);
        else setError('تعذر تحميل الفيديو.');
      })
      .catch(() => setError('حدث خطأ في تحميل الفيديو.'))
      .finally(() => setLoading(false));
  }, [courseVideoId]);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 animate-in fade-in duration-500" dir="rtl">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/95 backdrop-blur-xl transition-opacity"
        onClick={onClose}
      />

      {/* Video Container */}
      <div className="relative w-full max-w-5xl aspect-video bg-black rounded-lg shadow-[0_0_60px_rgba(0,0,0,0.8)] overflow-hidden border border-white/10 flex items-center justify-center">

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-50 w-12 h-12 bg-black/50 hover:bg-white/10 backdrop-blur-lg border border-white/10 rounded-full flex items-center justify-center transition-all group"
        >
          <X className="w-6 h-6 text-white/50 group-hover:text-white transition-colors" />
        </button>

        {loading ? (
          <div className="flex flex-col items-center justify-center z-10">
            <Loader2 className="w-14 h-14 text-teal-500 animate-spin mb-4" />
            <p className="text-white/50 font-bold">جاري تحضير العرض...</p>
          </div>
        ) : error ? (
          <div className="z-10">
            <p className="text-red-400 font-bold">{error}</p>
          </div>
        ) : (
          <iframe
            src={signedUrl}
            loading="lazy"
            style={{ border: 'none', position: 'absolute', top: 0, height: '100%', width: '100%' }}
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
            allowFullScreen={true}
            className="z-10"
            title="Course Trailer"
          />
        )}
      </div>
    </div>
  );
}